import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRightIcon } from "../../../../../assets/icons";
import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import { SwitchButton } from "../../../../../common/components/switch-button/SwitchButton";
import { useLazyGetEnergyAlertSettingsQuery, useSaveEnergyAlertConfigurationMutation } from "../../../../../service/energy-alerts-service";
import styles from "./unit-threshold-reminder-row.module.scss";
import { ApplicationRoutes } from "../../../../../routes";
import { trackLowThresholdReminderDisabled, trackLowThresholdReminderEnabled } from "../../../../../services/business-analytics/energyManagementEvents";

export const UnitThresholdReminderRow = () => {
	const navigate = useNavigate();
	const [fetchSettings, { data: settings }] = useLazyGetEnergyAlertSettingsQuery();

	useEffect(() => {
		fetchSettings();
	}, [fetchSettings]);
	const [saveConfiguration, { isLoading }] = useSaveEnergyAlertConfigurationMutation();

	const hasSavedThreshold = settings != null && settings.unitThreshold != null;
	const isOn = hasSavedThreshold && settings.isEnabled;

	const [pendingOn, setPendingOn] = useState<boolean | null>(null);
	const displayedOn = pendingOn ?? isOn;

	useEffect(() => {
		if (pendingOn !== null && pendingOn === isOn) {
			setPendingOn(null);
		}
	}, [pendingOn, isOn]);

	const handleToggle = async () => {
		if (!hasSavedThreshold) {
			navigate(ApplicationRoutes.CUSTOMER_UNIT_THRESHOLD_SETUP);
			return;
		}
		const next = !displayedOn;
		setPendingOn(next);
		try {
			await saveConfiguration({
				isEnabled: next,
				isReminderEnabled: settings.isReminderEnabled,
				unitThreshold: settings.unitThreshold ?? 0,
				isAutoRechargeEnabled: settings.isAutoRechargeEnabled,
				autoRechargeAmount: settings.autoRechargeAmount ?? 0,
				savedCardId: settings.savedCardId,
			}).unwrap();
			if (next) trackLowThresholdReminderEnabled(settings.unitThreshold);
			else trackLowThresholdReminderDisabled();
		} catch {
			setPendingOn(null);
		}
	};

	return (
		<div className={styles.card}>
			<CardFrame>
				<div className={styles.inner}>
					<span className={styles.label}>Unit Threshold & Reminder</span>
					<SwitchButton isActive={displayedOn} onChange={handleToggle} type="secondary" isLoading={isLoading} />
					<div className={styles.divider} />
					<div
						className={styles.chevron}
						onClick={e => {
							e.stopPropagation();
							navigate(ApplicationRoutes.CUSTOMER_UNIT_THRESHOLD_SETUP);
						}}
					>
						<ChevronRightIcon width={22} height={22} />
					</div>
				</div>
			</CardFrame>
		</div>
	);
};
